import { errorFactory } from '@/utils/error-utils';
import { IHTTPErrorMetaData } from '@/utils/api-utils/IHTTPErrorMetaData';
import { UnableToModifyResourceError } from '@/utils/errors';

/**
 * Error thrown when a password change fails because the provided
 * current password does not match the user's actual password.
 *
 * This is a domain-level error that abstracts away integration-specific
 * error details (e.g., SFCC's "current password is not valid" message).
 */
export const { InvalidCurrentPasswordError } = errorFactory(
  'InvalidCurrentPasswordError',
  UnableToModifyResourceError,
  { mapsToHTTPError: 'UnprocessableEntityError' } as IHTTPErrorMetaData
);
